import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { getBrandCustom } from "../../../util/getCustomColor";
import { colors } from "@zapalacorp/tokens";

export const Wrapper = styled("div")(() => ({
  maxWidth: "50%",
}));

const styles = makeStyles(() => ({
  subHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 30px",
    height: 64,
    boxShadow: "inset 0px -1px 0px #F0F0F0",
    backgroundColor: getBrandCustom("subHeaderBackgroundColor", "#F8FAFC"),
    fontFamily: "'Manrope', sans-serif",
    "@media (max-width: 600px)": {
      height: "fit-content",
    },
  },
  settingsHeaderVersion: {
    color: "#465869",
    fontSize: 12,
    lineHeight: "16px",
    fontWeight: "normal",
  },
  settingsHeaderBadge: {
    background: `${getBrandCustom("primaryColor", "#38cfc4")}  !important`,
    color: "#fff",
    borderRadius: 20,
    padding: "4px 8px",
    marginRight: 8,
  },
  title: {
    color: getBrandCustom("primaryColor", colors.gray800),
    fontFamily: "Manrope",
    fontWeight: 600,
    fontSize: 18,
    lineHeight: "24px",
  },
}));

export default styles;
